import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTrashBin12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconTrashBin12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 1h2v1H5zM4 2V1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h2.515a.5.5 0 0 1 0 1H10v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3h-.504a.5.5 0 1 1 0-1zM3 3v6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V3zm1 5.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0m3-4v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-1 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTrashBin12);
